<template>

    <div class="container">

        <app-head title="Users" />

        <account-link />

        <div class="my-4">
            <h1>{{ __('Users') }}</h1>
        </div>

        <div v-if="users.length === 0">
            {{ __('Keine Benutzer') }}
        </div>

        <div class="my-4">
            <inertia-link :href="route('users.create')" class="btn btn-outline-primary">
                <i class="bi bi-plus-lg"></i>
                {{ __('Benutzer erstellen') }}
            </inertia-link>
        </div>

        <div class="card">
            <div class="list-group list-group-flush">
                <inertia-link :href="route('users.edit', user)" 
                              class="list-group-item list-group-item-action d-flex align-items-center" 
                              v-for="(user, iterator, index) in users" 
                              :key="user.id">
                    <avatar :user="user" class="" v-if="user" /> 
                    <div class="ms-3">
                        <div class="fw-bold">
                            {{ user.full_name }}
                        </div>
                        <div>
                            {{ user.email }}
                        </div>
                    </div>
                    <div class="ms-auto">
                        <i class="bi bi-chevron-right"></i>
                    </div>
                </inertia-link>
            </div>
        </div>

    </div>

</template>

<script>
    import AccountLink from '@/shared/AccountLink';
        import Avatar from '@/shared/Avatar';


    export default {
        props: [
            'users',
        ],
        data() {
            return {
            }
        },
        components: {
            AccountLink,
            Avatar,
        },
        watch: {
        },
        methods: {

        },
    }
</script>